import {SET_PLANO_CAMPAIGNS, SET_SHARED_PLANO_CAMPAIGNS, SET_VIEW_CAMPAIGN_PANE, SET_SHARING_USERS} from '../actions/types';

const initialState = { planoCampaigns : [], sharedPlanoCampaigns : [], viewCampaignItem : {}, sharingUsers : [] };

export default (state = initialState, action)=>{
    switch(action.type){
        case SET_PLANO_CAMPAIGNS : {
            return { ...state, planoCampaigns : action.payload}
        }
        case SET_SHARED_PLANO_CAMPAIGNS : {
            return { ...state, sharedPlanoCampaigns : action.payload}
        }
        case SET_VIEW_CAMPAIGN_PANE : {
            return { ...state, viewCampaignItem : action.payload}
        }
        case SET_SHARING_USERS : {
            return { ...state, sharingUsers : action.payload}
        }
        default : {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/v3/reducers/planoCampainsReducer.js